<template>
  <v-layout>
    <v-flex xs12>
      <v-card tile flat>
        <v-card-title>HEAVY METAL RELEASE PAGE</v-card-title>
        <v-card outlined tile class="pa-0">
          <v-data-table
              :headers="headers"
              :items="samples"
              :loading="loading"
              :search="search"
              disable-pagination
              hide-default-footer
              group-by="customer_id"
              dense
          >
            <template v-slot:top>
              <v-card-actions>
                <v-text-field v-model="search" label="Search"></v-text-field>
                <v-spacer></v-spacer>
                <v-checkbox v-model="isReleased" label="Released"></v-checkbox>
                <v-spacer></v-spacer>
                <SampleQueue :queue="queue"></SampleQueue>
                <v-spacer></v-spacer>
                <v-btn @click="loadAll" :disabled="loading" icon><v-icon>mdi-refresh</v-icon></v-btn>
              </v-card-actions>
              <v-divider></v-divider>
            </template>
            <template v-slot:group.header="{headers, group, items, isOpen, toggle, remove}">
              <td :colspan="headers.length">
                <SampleGroupCustomerInfo :customer="customer(group)"></SampleGroupCustomerInfo>
              </td>
            </template>
            <template v-slot:item.sample_tests="{item}">
              <SampleRequiredTests :sample_tests="item.sample_tests"></SampleRequiredTests>
            </template>
            <template v-slot:item.is_released="{item}">
              <v-tooltip v-if="!queue.has(item.id)" top>
                <template v-slot:activator="{on}">
                  <v-btn :disabled="item.releasing || item.is_released" @click="sendHeavyMetal(item)" v-on="on" color="white" class="success" icon tile small><v-icon>mdi-check</v-icon></v-btn>
                </template>
                <span>Approve {{item.id}}</span>
              </v-tooltip>
              <v-chip v-else color="primary">{{queue.get(item.id).status}}</v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
name: "index",
  components:{
    SampleRequiredTests: () => import("./components/SampleRequiredTests"),
    SampleGroupCustomerInfo: () => import("./components/SampleGroupCustomerInfo"),
    SampleQueue: () => import("./components/SampleQueue")
  },
  data: () => ({
    loadingSamples: false,
    loadingTestTypes: false,
    loadingCustomerInfo: false,
    loadingBilling: false,
    search: null,
    isReleased: false,
    headers:[
      {
        text: "Approve",
        value: "is_released",
        width: '50px'
      },
      {
        text: "ID",
        value: 'id',
        width: '50px',
      },
      {
        text: "Required Tests",
        value: "sample_tests",
        width: "400px"
      },
      {
        text: "Strain",
        value: "name"
      },
      {
        text: "Type",
        value: "sample_type_name",
      },
      {
        text: "QA",
        value: "qa"
      }
    ],
    queue: new Map(),
    listener: null,
  }),
  mounted(){
    this.loadAll();
    this.listenToMostRecentQueue()
  },
  computed:{
    samples(){
      return this.$store.$db().model('samples').query().where('qa_approved', true).where('is_released', this.isReleased).with('sample_tests').orderBy('id', 'desc').get();
    },
    loading(){
      return this.loadingSamples ||
      this.loadingTestTypes ||
      this.loadingCustomerInfo ||
      this.loadingBilling;
    },
  },
  methods:{
    listenToMostRecentQueue(){
      this.listener = this.$firestore.collection('heavy_metals').limit(5).onSnapshot(snap => {
        snap.docChanges().forEach(change => {
          let data = change.doc.data();
          if (change.type === "added" || change.type === "modified") {
            this.queue.set(data.sample_id, {
              ...data,
              ref: change.doc.ref,
              id: change.doc.id
            })
          }
          if (change.type === "removed") {
            this.queue.delete(data.sample_id);

          }
        })
      })
    },
    async requeueSample(item){
      const queueItem = {...item}
      await item.ref.delete();
      await this.$firestore.collection("heavy_metals").doc(queueItem.id).set({
        sample_id: queueItem.sample_id,
        status: "In Queue",
        message: null,
        data: null,
      })
    },
    loadAll(){
      // this.$store.dispatch('entities/deleteAll');
      this.$store.$db().model('customers').deleteAll();
      this.$store.$db().model('contacts').deleteAll();
      this.$store.$db().model('names').deleteAll();
      this.$store.$db().model('billings').deleteAll();
      this.$store.$db().model('samples').deleteAll();
      this.$store.$db().model('sampleTests').deleteAll();
      this.getSamples();
      // this.getTestTypes();
      this.getCustomerInfo()
      this.getBilling()
    },
    async getTestTypes(){
      this.loadingTestTypes = true
      await this.$store.$db().model('sampleTestTypes').api().fetch();
      this.loadingTestTypes = false;
    },
    async getCustomerInfo(){
      this.loadingCustomerInfo = true
      this.$store.$db().model('customers').api().fetch({
        with: 'primaryName,contract'
      });
      this.loadingCustomerInfo = false;
    },
    async getBilling(){
      this.loadingBilling = true;
      this.$store.$db().model('billings').api().fetch()
      this.loadingBilling = false;
    },
    async getSamples(){
      this.loadingSamples = true;
      await this.$store.$db().model('samples').api().fetch({
        with: 'sampleTests',
        where: {
          key: "qa_approved",
          value: true
        }
      })
      this.loadingSamples = false;
    },
    customer(id){
      return this.$store.$db().model("customers").query().with(['billing', 'contract.contract_type']).find(id);
    },
    sendAllHeavyMetal(items){
      items.filter(item => !item.is_released && !item.releasing).each(item => this.sendHeavyMetal(item))
    },
    async sendHeavyMetal(sample){
      let checkDoc = this.$firestore.collection("heavy_metals").doc(sample.uuid).get();
      if(checkDoc.exists){
        let data = checkDoc.data();
        this.$store.dispatch("showError","Sample has already been uploaded: Status: "+data.status)
        return;
      }
      this.$store.$db().model('samples').update({
        where: sample.uuid,
        data: {releasing: true}
      })
      await this.$firestore.collection("heavy_metals").doc(sample.uuid).set({
        sample_id: sample.id,
        status: "In Queue",
        message: null,
        data: null,
      })
    }
  },
  beforeRouteLeave(from, to, next){
    this.$store.$db().model('customers').deleteAll();
    this.$store.$db().model('contacts').deleteAll();
    this.$store.$db().model('names').deleteAll();
    this.$store.$db().model('billings').deleteAll();
    this.$store.$db().model('samples').deleteAll();
    this.$store.$db().model('sampleTests').deleteAll();
    if(this.listener !== null){
      this.listener();
    }
    next();
  },
}
</script>

<style scoped>

</style>
